import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, App, Platform, Content } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Keyboard } from '@ionic-native/keyboard';
import { Subscription } from 'rxjs/rx';
//Pages
import { TabsPage } from '../tabs/tabs';
import { HomePage } from '../home/home';
//Providers
import { AuthProvider } from '../../providers/auth-provider';
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { UserProvider } from '../../providers/user-provider';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
//Models
import { Auth } from '../../models/auth.model';
import { Congresso } from '../../models/congresso.model';

@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
    providers: [InAppBrowser]
})
export class LoginPage {

    @ViewChild(Content) content: Content;

    private user = new Auth();
    private congresso: Congresso;
    private nav: NavController;
    private onShowSubscription: Subscription;
    private onHideSubscription: Subscription;

    constructor(
        public navParams: NavParams,
        private authProvider: AuthProvider,
        private utilProvider: UtilProvider,
        private userProvider: UserProvider,
        private app: App,
        private keyboard: Keyboard,
        private config: ConfigProvider,
        public viewCtrl: ViewController,
        private alert: CustomAlert,
        private iab: InAppBrowser) {

        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.nav = app.getActiveNav();

    }

    ionViewDidEnter() {
        this.keyboard.disableScroll(true);
        let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
            appElHeight = appEl.clientHeight;

        this.onShowSubscription = this.keyboard.onKeyboardShow().subscribe((e) => {
            appEl.style.height = ((appElHeight) - (<any>e).keyboardHeight) + 'px';
        });

        this.onHideSubscription = this.keyboard.onKeyboardHide().subscribe((e) => {
            appEl.style.height = '100%';
        });
    }

    authenticate(form) {
        let self = this;
        let connected = self.utilProvider.isConnected(true);
        if (connected) {
            self.utilProvider.loadingShow();
            self.authProvider.login(self.user)
                .then((data) => {

                    let ano = this.congresso ? this.congresso.Ano : this.config.ANO_ATUAL;
                    self.userProvider.getAtividadesInscritasIdsUsuario(data.Guid, ano)
                        .then(d => {

                            if (d)
                                localStorage.setItem('atividadesInscritas', JSON.stringify(d))
                        });

                    self.userProvider.getPalestrantesFavoritos(data.Guid, ano)
                        .then(r => {

                            if (r)
                                localStorage.setItem('palestrantesFavoritos', JSON.stringify(r.resposta.retorno))
                        });

                    self.userProvider.getAtividadesAssistidasIdsUsuario(data.Guid, ano)
                        .then(d => {

                            if (d)
                                localStorage.setItem('atividadesAssistidas', JSON.stringify(d))
                        });


                    self.utilProvider.loadingHide();

                    this.dismiss();

                    this.nav.last()._didEnter();

                    //let tab = this.app.getRootNav().getActiveChildNav();
                    //this.app.getRootNav().setRoot(TabsPage, { id: tab.selectedIndex });
                })
                .catch(response => {
                    let data = response;
                    if (data && connected) {

                        self.alert.showAlert('Erro', 'Erro ao fazer login. Verifique se o login e a senha estão corretos')
                    }
                    self.utilProvider.loadingHide();
                });
        }
        return false;
    }

    openUrl(url, inNativeBrowser) {
        if (this.utilProvider.isNullOrEmpty(url) || url == '#')
            return false;

        if (inNativeBrowser) {

            const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
            browser.show();

        } else {
            const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
            browser.show();
        }
    }

    focusElement(element: any) {

        //var bodyRect = document.body.getBoundingClientRect(),
        //    elemRect = element.getBoundingClientRect(),
        //    offset = elemRect.top - bodyRect.top;
        //this.content.scrollTo(0, element.center.y);
    }

    dismiss() {
        let appEl = <HTMLElement>(document.getElementsByTagName('ION-APP')[0]),
            appElHeight = appEl.clientHeight;
        appEl.style.height = '100%';
        this.keyboard.disableScroll(false);
        this.onShowSubscription.unsubscribe();
        this.onHideSubscription.unsubscribe();
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts